/* @flow */

import React from 'react';
import ResourceItem from './ResourceItem';
import { ResourceTypes } from 'bucket/constants';
import cx from 'classnames';
import { getResourceTypeLabelPlural } from 'bucket/constants';
import { Divider } from 'semantic-ui-react';

type Props = {
  category: ResourceType,
  resources: Array<BucketResource>,
  onUpdateResource: (resource: BucketResource) => void,
  onCropResource: (resource: BucketResource, conf: CropConfig) => void,
  onRemoveResource: (resource: BucketResource) => void,
  isRemovingResource: boolean,
};

const getCardsNumberByCategory = category => {
  switch (category) {
    case ResourceTypes.IMAGE:
    case ResourceTypes.PDF:
      return 'three';
    case ResourceTypes.VIDEO:
      return 'two';
    default:
      return 'three';
  }
};

const getCardsClass = category =>
  cx('ui cards', getCardsNumberByCategory(category));

const ResourceCategory = ({
  category,
  resources,
  onUpdateResource,
  onCropResource,
  onRemoveResource,
  isRemovingResource,
}: Props) => (
  <div>
    <h2 className="ui header">{getResourceTypeLabelPlural(category)}</h2>
    <Divider />
    <div className={getCardsClass(category)}>
      {resources.map(r => (
        <ResourceItem
          key={r.id}
          resource={r}
          resources={resources}
          onUpdate={onUpdateResource}
          onCrop={onCropResource}
          onRemove={onRemoveResource}
          isRemoving={isRemovingResource}
        />
      ))}
    </div>
    <Divider hidden />
  </div>
);

export default ResourceCategory;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folder/components/ResourceCategory.js